<script setup>
import { useReferenceWorkspace } from "./referenceWorkspace";
import * as Icon from "@heroicons/vue/24/solid";
const props = defineProps({
  sectionId: { type: String, required: true },
  title: { type: String, required: true },
  label: { type: String, required: true },
  placeholder: { type: String, required: true },
});
const {
  reference,
  sectionSaving,
  sectionEditing,
  sectionEditButtonClasses,
  sectionDoneButtonClasses,
  setSectionRef,
  setEditingSection,
  stopEditing,
  saveSection,
} = useReferenceWorkspace();
</script>

<template>
  <section
    :id="props.sectionId"
    :ref="(el) => setSectionRef(props.sectionId, el)"
    class="min-w-0 scroll-mt-24 2xl:col-span-6"
  >
    <div class="mb-3 flex flex-wrap items-center justify-between gap-3">
      <div>
        <div
          class="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400"
        >
          {{ props.label }}
        </div>
        <h2 class="text-xl font-semibold text-slate-900 dark:text-slate-100">
          {{ props.title }}
        </h2>
      </div>
      <div class="flex flex-wrap items-center gap-2">
        <button
          v-if="!sectionEditing[props.sectionId]"
          :class="sectionEditButtonClasses"
          @click.prevent="setEditingSection(props.sectionId)"
        >
          <Icon.PencilSquareIcon class="mr-1 inline h-4 w-4" /> Edit
        </button>
        <button
          v-if="sectionEditing[props.sectionId]"
          :class="sectionDoneButtonClasses"
          @click.prevent="stopEditing(props.sectionId)"
        >
          Done
        </button>
        <button
          v-if="sectionEditing[props.sectionId]"
          class="btn save"
          :disabled="sectionSaving[props.sectionId]"
          @click.prevent="saveSection(props.sectionId)"
        >
          <Icon.CheckIcon
            v-if="!sectionSaving[props.sectionId]"
            class="mr-1 inline h-4 w-4"
          />{{ sectionSaving[props.sectionId] ? "Saving..." : "Save" }}
        </button>
      </div>
    </div>

    <FormBox :header="props.label">
      <textarea
        v-if="sectionEditing[props.sectionId]"
        v-model="reference.data[props.sectionId]"
        :aria-label="props.title"
        class="reference-text-content w-full min-h-36"
      ></textarea>
      <span v-else class="reference-text-content block whitespace-pre-line">
        {{ reference.data[props.sectionId] ?? props.placeholder }}
      </span>
    </FormBox>
  </section>
</template>
